(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.HanezzaProductState = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  function numberOrNull(value) {
    if (value === null || value === undefined || value === '') return null;
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function normalizeVariant(raw) {
    raw = raw || {};
    var image = raw.featured_image || raw.featuredImage || null;
    return {
      id: raw.id,
      available: Boolean(raw.available),
      price: numberOrNull(raw.price),
      compareAtPrice: numberOrNull(raw.compare_at_price != null ? raw.compare_at_price : raw.compareAtPrice),
      options: Array.isArray(raw.options) ? raw.options.slice() : [],
      featuredImageId: image && image.id != null ? image.id : null,
      featuredImageSrc: image && image.src ? String(image.src) : null,
      title: raw.title == null ? '' : String(raw.title)
    };
  }

  function resolveVariant(variants, optionNames, selectedOptions) {
    var names = Array.isArray(optionNames) ? optionNames : [];
    var selected = selectedOptions || {};
    if (!names.length || names.some(function(name) {
      return !Object.prototype.hasOwnProperty.call(selected, name) || selected[name] === '' || selected[name] == null;
    })) return null;

    return (Array.isArray(variants) ? variants : []).find(function(variant) {
      if (!variant || !Array.isArray(variant.options) || variant.options.length < names.length) return false;
      return names.every(function(name, index) {
        return variant.options[index] === selected[name];
      });
    }) || null;
  }

  function formatTry(cents) {
    var amount = numberOrNull(cents);
    if (amount === null) return '';
    var formatted = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount / 100);

    // Keep Hanezza's established amount-first visual order while relying on
    // Intl for Turkish grouping and decimal rules.
    return formatted.replace(/\s*₺\s*/g, '').trim() + '\u00a0₺';
  }

  function buildProductState(variant, optionNames, selectedOptions) {
    if (!variant) return null;
    var normalized = normalizeVariant(variant);
    var selections = {};
    (Array.isArray(optionNames) ? optionNames : []).forEach(function(name) {
      if (selectedOptions && Object.prototype.hasOwnProperty.call(selectedOptions, name)) {
        selections[name] = selectedOptions[name];
      }
    });

    return {
      variantId: normalized.id,
      price: normalized.price,
      priceText: formatTry(normalized.price),
      compareAtPrice: normalized.compareAtPrice,
      comparePriceText: formatTry(normalized.compareAtPrice),
      available: normalized.available,
      selectedOptions: selections,
      featuredImageId: normalized.featuredImageId,
      featuredImageSrc: normalized.featuredImageSrc
    };
  }

  function each(root, selector, callback) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    Array.prototype.forEach.call(root.querySelectorAll(selector), callback);
  }

  function applyProductState(root, state) {
    if (!state) return null;

    each(root, '[data-product-variant-id]', function(node) {
      if ('value' in node) node.value = String(state.variantId == null ? '' : state.variantId);
      else node.textContent = String(state.variantId == null ? '' : state.variantId);
    });

    each(root, '[data-product-price]', function(node) {
      node.textContent = state.priceText;
    });

    each(root, '[data-product-compare-price]', function(node) {
      var visible = state.compareAtPrice != null && state.price != null && state.compareAtPrice > state.price;
      node.textContent = visible ? state.comparePriceText : '';
      node.hidden = !visible;
    });

    each(root, '[data-product-availability]', function(node) {
      node.setAttribute('data-available', state.available ? 'true' : 'false');
      var availableText = node.dataset && node.dataset.availableText;
      var unavailableText = node.dataset && node.dataset.unavailableText;
      if (availableText || unavailableText) {
        node.textContent = state.available ? (availableText || '') : (unavailableText || '');
      }
    });

    each(root, '[data-option-name][data-option-value]', function(node) {
      var name = node.getAttribute('data-option-name');
      var value = node.getAttribute('data-option-value');
      var selected = Object.prototype.hasOwnProperty.call(state.selectedOptions, name) && state.selectedOptions[name] === value;
      node.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (node.classList && typeof node.classList.toggle === 'function') node.classList.toggle('selected', selected);
    });

    each(root, '[data-selected-option-label]', function(node) {
      var name = node.getAttribute('data-option-name');
      if (Object.prototype.hasOwnProperty.call(state.selectedOptions, name)) {
        node.textContent = state.selectedOptions[name];
      }
    });

    return state;
  }

  return {
    normalizeVariant: normalizeVariant,
    resolveVariant: resolveVariant,
    formatTry: formatTry,
    buildProductState: buildProductState,
    applyProductState: applyProductState
  };
});
